import React, { useEffect, useState } from "react";
import "../styles/navbar.css";
import { initializeDarkMode, handleDarkModeToggle } from "../components/DarkMode";
import moonblack from "../utils/moon-black.svg";
import menu from '../utils/menu-light.svg';
import Sidebar from "./Sidebar";
import logo from '../utils/logo/logo-black.png'

export default function Navbar({
  homeSectionRef,
  projectSectionRef,
  aboutSectionRef,
  contactSectionRef,
  publicationRef,
}) {
  const [showBorder, setShowBorder] = useState(false);
  const [showOptions, setShowOptions] = useState(true);
  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    initializeDarkMode();
    window.addEventListener("scroll", handleScroll);
    handleResize(); // Check initial window width
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setShowBorder(true);
    } else {
      setShowBorder(false);
    }
  };

  const handleResize = () => {
    if (window.innerWidth <= 640) {
      setShowOptions(false);
    } else {
      setShowOptions(true);
    }
  };

  const scrollDown = (ref) => {
    window.scrollTo({
      top: ref.current.offsetTop,
      behavior: "smooth",
    });
  };

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <div className={`navbar ${showSidebar ? 'show' : ''}`}>
      <div className="nav-left">
        {/* <h1 className="nav-name">Ketkar.</h1> */}
        <img src={logo} alt="" className="logo"/>
      </div>

      <div className={`nav-right`}>
        <ul className={`options ${showOptions ? "" : "hide"}`}>
          <li
            className={`nav-links ${showBorder ? "" : "hide"}`}
            onClick={() => scrollDown(homeSectionRef)}
          >
            Home
          </li>
          <li
            className={`nav-links ${showBorder ? "" : "hide"}`}
            onClick={() => scrollDown(aboutSectionRef)}
          >
            About Me
          </li>
          <li
            className={`nav-links ${showBorder ? "" : "hide"}`}
            onClick={() => scrollDown(projectSectionRef)}
          >
            Projects
          </li>
          <li
            className={`nav-links ${showBorder ? "" : "hide"}`}
            onClick={() => scrollDown(publicationRef)}
          >
            Publications
          </li>
          <li
            className={`nav-links ${showBorder ? "" : "hide"}`}
            onClick={() => scrollDown(contactSectionRef)}
          >
            Contact
          </li>
        </ul>

        <img
          src={moonblack}
          alt="night-mode"
          id="themeBtn"
          className="themeBtn"
          onClick={handleDarkModeToggle}
        />

        <img
          src={menu}
          alt="menu-icon"
          id="menuBtn"
          className={`menu-icon ${showOptions ? "hide" : ""}`}
          onClick={toggleSidebar}
        />
      </div>

      <Sidebar
        homeSectionRef={homeSectionRef}
        projectSectionRef={projectSectionRef}
        aboutSectionRef={aboutSectionRef}
        contactSectionRef={contactSectionRef}
        publicationRef={publicationRef}
      />
    </div>
  );
}
